import { supabase } from '../lib/supabase';

export const getAuthRedirectUrl = (path: string) => {
  const base = import.meta.env.VITE_APP_URL || window.location.origin;
  return `${base.replace(/\/$/, '')}${path}`;
};

export const signUpWithOTP = async (email: string, options?: { 
  redirectTo?: string,
  data?: Record<string, any>
}) => {
  try {
    const { data, error } = await supabase.auth.signInWithOtp({
      email,
      options: {
        emailRedirectTo: options?.redirectTo,
        data: options?.data
      }
    });

    if (error) throw error;
    
    return { data, error: null };
  } catch (error) {
    console.error('Error sending OTP:', error);
    return { data: null, error };
  }
};

export const verifyOTP = async (email: string, token: string) => {
  try {
    const { data, error } = await supabase.auth.verifyOtp({
      email,
      token,
      type: 'email'
    });

    if (error) throw error;
    
    return { data, error: null };
  } catch (error) {
    console.error('Error verifying OTP:', error);
    return { data: null, error };
  }
};

export const createUserProfile = async (userId: string, userData: any) => {
  try {
    const { data, error } = await supabase
      .from('users')
      .insert({
        id: userId,
        email: userData.email,
        name: userData.name,
        phone: userData.phone,
        account_type: userData.accountType || 'individual',
        subscription_tier: 'free',
        verified: true
      })
      .select()
      .single();

    if (error) throw error;
    
    return { data, error: null };
  } catch (error) {
    console.error('Error creating user profile:', error);
    return { data: null, error };
  }
};

export const signIn = async (email: string, password: string) => {
  try {
    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    return { data, error };
  } catch (error) {
    console.error('Error signing in:', error);
    return { data: null, error };
  }
};

export const signOut = async () => {
  try {
    const { error } = await supabase.auth.signOut();
    return { error };
  } catch (error) {
    console.error('Error signing out:', error);
    return { error };
  }
};

export const getCurrentUser = async () => {
  try {
    const { data: { user }, error } = await supabase.auth.getUser();
    return { user, error };
  } catch (error) {
    console.error('Error getting current user:', error);
    return { user: null, error };
  }
};

export const resetPassword = async (email: string) => {
  try {
    const { data, error } = await supabase.auth.resetPasswordForEmail(
      email.trim().toLowerCase(),
      {
        redirectTo: getAuthRedirectUrl('/reset-password'),
      }
    );
    return { data, error };
  } catch (error) {
    console.error('Error resetting password:', error);
    return { data: null, error };
  }
};

export const updatePassword = async (newPassword: string) => {
  try {
    const { data, error } = await supabase.auth.updateUser({
      password: newPassword,
    });
    return { data, error };
  } catch (error) {
    console.error('Error updating password:', error);
    return { data: null, error };
  }
};